var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"uk-text-meta uk-margin-remove-top"},_vm._l((_vm.genres),function(genre){return _c('span',{key:genre.id,staticClass:"uk-badge uk-margin-small-right"},[_vm._v(_vm._s(genre.name))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }